export default "__VITE_ASSET__CZzk57eP__"